import React, { useState } from "react";
import Layout from "../../Components/Global/Layout";
import BreadCrumb from '../../Components/Global/BreadCrumb/BreadCrumb';
import BlogEdit from "../../Components/Blog/BlogEdit/BlogEdit";
import Button from "../../Components/Global/Button";
import Alert from "../../Components/Alert/Alert";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect } from "react";
import { useStore } from "../../Utils/utils";

const BlogEditPage = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const [alert, setAlert] = useState();
    const [storeName, setStoreName] = useState([]);
    const { store, setStore } = useStore();

    console.log("storeName", storeName);
    
     useEffect(() => {
            if (storeName?.length == 0 || storeName == undefined) {
                setStoreName(() => [store?.name]);
            } else {
                setStoreName((existingStoreId) => [...existingStoreId, store?.name]);
            }
        }, [store?.id]);
    
        useEffect(() => {
            if (storeName[1] != undefined) {
                if (storeName[0] != storeName[1]) {
                    navigate("/admin");
                    setStoreName([]);
                }
            }
        }, [storeName]);

    const onUpdateBlog = (type) => {
        if (type === "success") {
            setAlert({ text: "Blog updated successfully", type: "success" });
        } else {
            setAlert({ text: "Error updating blog", type: "error" });
        }
    }

     const storeFrontUrl = process.env.REACT_APP_STORE_FRONT_URL;
  const navigateToStoreFront = () => {
    if (store) {
      const cleanBase = storeFrontUrl.replace(/^https?:\/\//, "");

      const url = store?.is_separate_store
        ? store?.sub_domain?.trim()
          ? `https://${store.sub_domain}.${cleanBase}/blog/${id}${store?.slug ? `?slug=${store.slug}` : ""}`
          : `https://${cleanBase}/blog/${id}${store?.slug ? `?slug=${store.slug}` : ""}`
        : `${storeFrontUrl}/blog/${id}${store?.slug ? `?slug=${store.slug}` : ""}`;

      window.open(url, "_blank", "noopener,noreferrer");
    }
  };

  console.log("store", store);
  

    return (
        <Layout>
            <div className="breadcrumb-wrapper breadcrumb-contacts">
                <div className="d-flex flex-column">
                    <BreadCrumb />
                </div>
                <Button className={'btn btn-primary'} onClick={() => navigateToStoreFront()} value="View Blog" />
            </div>
            {alert?.text && (
                <div className="text-center">
                    <Alert text={alert.text} type={alert.type} setAlert={setAlert} />
                </div>
            )}
            <div className=" card-default">
                <div className="card-body">
                    <BlogEdit onUpdateBlog={onUpdateBlog} />
                </div>
            </div>
        </Layout>
    )
}
export default BlogEditPage;
